<template>
  <div class="left-panel">
    <template v-if="!$store.state.chinaMap.currentlyMapAdcode">
      <BarChart
        title="保供每省公司数量TOP10"
        :dataType="$store.state.chinaMap.dataType == 3 ? '1,3' : undefined"
        style="height: 50%"
      />
      <BarChart
        title="服务每省公司数量TOP10"
        dataType="2,3"
        v-if="$store.state.chinaMap.dataType == 3"
        style="height: 50%"
      />
      <priceTrend
        v-if="$store.state.chinaMap.dataType !== 3"
        style="height: 50%"
      />
    </template>
    <template v-else>
      <Statistics style="height: 50%" />
      <pie-chart style="height: 50%" />
    </template>
  </div>
</template>

<script>
import Statistics from '@/views/ChinaMapData/components/body/left/Statistics.vue';
import BarChart from '@/views/ChinaMapData/components/body/left/BarChart.vue';
import PieChart from '@/views/ChinaMapData/components/body/left/PieChart.vue';
import priceTrend from '@/views/ChinaMapData/components/body/left/priceTrend.vue';
export default {
  name: 'LeftPanel',
  components: { Statistics, BarChart, PieChart, priceTrend },
};
</script>

<style scoped>
.left-panel {
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
